import React from "react";
import { View, TextInput } from "react-native";
import { Feather } from "@expo/vector-icons";
import { FONT_FAMILY } from "../styles";

const Search = ({
  placeholder,
  value,
  onChangeText,
  searchOnPress,
  customStyle,
}: {
  placeholder?: string;
  value?: string;
  onChangeText?: (text: string) => void;
  searchOnPress?: () => any;
  customStyle?: any;
}) => {
  return (
    <View
      style={[
        {
          flexDirection: "row",
          width: "40%",
          justifyContent: "space-between",
          alignItems: "center",
        },
        customStyle ? customStyle : null,
      ]}
    >
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          backgroundColor: "#7D7D7D1A",
          borderRadius: 5,
          alignItems: "center",
        }}
      >
        <Feather
          style={{ marginStart: 20 }}
          name="search"
          color="#ADADAD"
          size={20}
        />
        <TextInput
          style={{
            width: "100%",
            paddingVertical: 15,
            paddingHorizontal: 10,
            outline: "none",
            fontFamily: FONT_FAMILY.notosans,
            fontSize: 14,
          }}
          placeholder={placeholder}
          placeholderTextColor="#ADADAD"
          value={value}
          onChangeText={onChangeText}
          onKeyPress={({ nativeEvent }) => {
            if (nativeEvent.key === "Enter") {
              searchOnPress?.();
            }
          }}
        />
      </View>
    </View>
  );
};

export default Search;
